module.exports = __webpack_public_path__ + "static/media/lobby_bg.2057cad6.svg";